import { render } from "./SpendenDisplay.vue?vue&type=template&id=2d2eaf60&scoped=true"
import script from "./SpendenDisplay.vue?vue&type=script&lang=js"
export * from "./SpendenDisplay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2eaf60"]])

export default __exports__